import { branch, compose, renderNothing, withProps, lifecycle, renderComponent, withPropsOnChange } from 'recompose';
import { getOr } from 'lodash/fp';
import { get } from 'lodash';

import BrandSchedule from '../components/BrandSchedule';
import {
  canUserModifyBarbers,
  canUserModifySchedules,
  canUserViewSchedules,
} from '../../../../../common/helpers/users';
import { LOCATIONS_ALL_ID } from '../../../containers/BrandBarber/constants';
import AllOrEmptyLocations from '../components/AllOrEmptyLocations';
import getScheduleSummary from '../helpers/getScheduleSummary';
import withMinInterval from '../../../containers/BrandBarber/hoc/withMinInterval';
import { getAllLocationsSchedules, getLocationSchedule } from '../helpers/scheduleHelpers';
import { withScheduleTabs } from '../../../../../common/schedulesForm/schedulesFormContainer';
import { getBarberShopScheduleWithConflicts } from '../../../scheduleConflictsHelpers';

const ScheduleContainer = compose(
  branch(
    props => !canUserViewSchedules(props.permissions), renderNothing,
  ),
  branch(
    props =>
      !props.selectedLocation ||
      props.selectedLocation === LOCATIONS_ALL_ID,
    renderComponent(AllOrEmptyLocations),
  ),
  withMinInterval,
  withScheduleTabs,
  withProps(
    props => ({
      canModify: canUserModifyBarbers(props.permissions) && canUserModifySchedules(props.permissions),
      selectedLocationSchedule: getLocationSchedule(props.formValues, props.selectedLocation),
    })
  ),
  withPropsOnChange(['selectedLocation'], props => ({
    otherShopsSchedules: getAllLocationsSchedules(
      props.formValues, [props.selectedLocation, LOCATIONS_ALL_ID]
    ),
  })),
  withPropsOnChange(['selectedLocationSchedule'], (props) => {
    const selectedShop = props.barberShops.find(shop => shop.id === props.selectedLocation);

    const currentConflicts = getBarberShopScheduleWithConflicts({
      otherShopsSchedules: props.otherShopsSchedules,
      shopSchedule: props.selectedLocationSchedule.current,
      shopNamesById: props.shopNamesById,
      shop: selectedShop,
    });
    const futureConflicts = getBarberShopScheduleWithConflicts({
      otherShopsSchedules: props.otherShopsSchedules,
      shopSchedule: props.selectedLocationSchedule.future,
      shopNamesById: props.shopNamesById,
      shop: selectedShop,
    });

    const currentSchedules = getOr({}, 'current', props.selectedLocationSchedule);
    const futureSchedules = getOr({}, 'future', props.selectedLocationSchedule);

    const currentScheduleSummary = getScheduleSummary({
      shopSchedules: getAllLocationsSchedules(props.formValues, [LOCATIONS_ALL_ID]),
      fieldName: 'current',
      shops: props.barberShops,
      shopNamesById: props.shopNamesById,
    });
    const futureScheduleSummary = getScheduleSummary({
      shopSchedules: getAllLocationsSchedules(props.formValues, [LOCATIONS_ALL_ID]),
      fieldName: 'future',
      shops: props.barberShops,
      shopNamesById: props.shopNamesById,
    });


    return {
      schedules: {
        current: {
          ...currentSchedules,
          conflicts: currentConflicts,
        },
        future: {
          ...futureSchedules,
          conflicts: futureConflicts,
        },
      },
      scheduleSummary: {
        current: currentScheduleSummary,
        future: futureScheduleSummary,
      },
    };
  }),
  lifecycle({
    componentWillUpdate(nextProps) {
      const { change, schedules } = this.props;
      const futureStartDate = get(schedules, 'future.startDate');
      const nextFutureStartDate = get(nextProps.schedules, 'future.startDate');
      const nextFutureEndDate = get(nextProps.schedules, 'future.endDate');
      const endDate = get(schedules, 'current.endDate');
      const nextEndDate = get(nextProps.schedules, 'current.endDate');

      const endDateRemoved = endDate && !nextEndDate;
      const futureStartDateRemoved = futureStartDate && !nextFutureStartDate;
      const needToRemoveFutureEndDate = futureStartDateRemoved && nextFutureEndDate;

      if (endDateRemoved || needToRemoveFutureEndDate) {
        change(`${nextProps.formSectionName}.schedules.future.startDate`, null);
        change(`${nextProps.formSectionName}.schedules.future.endDate`, null);

        get(nextProps.schedules, 'future.workdays', [])
          .forEach((workday, index) => {
            change(`${nextProps.formSectionName}.schedules.future.workdays[${index}].enabled`, false);
          });
      }
    },
  }),
)(BrandSchedule);

export default ScheduleContainer;
